import { persist, setSerialization, createSessionStorage } from '@macfja/svelte-persistent-store';
import { writable } from 'svelte/store';
import { customSerialization } from './serialization.js';
import { createUserStorage } from './storage.js';

setSerialization(...customSerialization);

export const currentUser = persist(writable([]), createUserStorage(), 'user');
export const classes = persist(writable([]), createUserStorage(), 'classes');
export const classesLastUpdated = persist(writable(null), createUserStorage(), 'classesLastUpdated');
export const userContentActions = persist(writable([]), createUserStorage(), 'userContentActions');
export const userSubscriptions = persist(writable([]), createUserStorage(), 'userSubscriptions');
export const userSubscriptionsLastUpdated = persist(writable([]), createUserStorage(), 'userSubscriptionsLastUpdated');
export const classJoinCode = persist(writable(null), createSessionStorage(), 'classJoinCode');

export const deleteStore = () => {
    currentUser.delete();
    classes.delete();
    classesLastUpdated.delete();
    userContentActions.delete();
    userSubscriptions.delete();
    userSubscriptionsLastUpdated.delete();
    classJoinCode.delete();

    classes.set([]);
    currentUser.set([]);
    classesLastUpdated.set(null);
    userContentActions.set([]);
    userSubscriptions.set([]);
    userSubscriptionsLastUpdated.set(null);
    classJoinCode.set(null);
};